import { ChangeDetectionStrategy, Component, inject, output, signal } from '@angular/core';
import { Router } from '@angular/router';

interface NavItem {
  label: string;
  href: string;
}

@Component({
  selector: 'krc-krc-header',
  standalone: true,
  imports: [],
  templateUrl: './krc-header.html',
  styleUrl: './krc-header.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KrcHeader {
  private readonly router = inject(Router);

  readonly menuOpen = signal(false);

  readonly openPropertyIntake = output<void>();

  // Logo click: if already on the landing page, scroll to the top; else go there.
  // (The landing-v3 component is served at the '/landing' route.)
  goHome(): void {
    this.closeMenu();
    if (this.router.url.split(/[?#]/)[0] === '/landing') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      this.router.navigate(['/landing']);
    }
  }

  readonly navItems: NavItem[] = [
    { label: 'How It Works', href: '#kore-adu' },
    { label: 'The Kore ADU', href: '#meet-kore' },
    { label: 'Why Kore Works', href: '#why-kore' },
    { label: 'About Kore', href: '#about-kore' },
  ];

  toggleMenu(): void {
    this.menuOpen.update((open) => !open);
  }

  closeMenu(): void {
    this.menuOpen.set(false);
  }

  goToPropertyIntake(): void {
    this.closeMenu();
    this.openPropertyIntake.emit();
  }
}
